import React from "react";
import M_ColumnMatch from "./M_ColumnMatch";
import Text from "../../components/common/Text";
import Latex from "react-latex-next";
import Image from "../../components/common/Image";

import M_MultipleChoice from "./M_MultipleChoice";
import M_SelectTrue from "./M_SelectTrue";
import M_Order from "./M_Order";
import M_Type from "./M_Type";
import QuestionText from "../Partials/QuestionText";
import Button from "../../components/common/Button";
import { Lightbulb } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { Typography } from "@mui/material";
import Div from "../../components/common/Div";

export default function MemoQuestion(props) {
  const question = props.question;
  const answer = props.answer;
  const questionNumber = props.questionNumber;
  const history = useHistory();
  function getCorrectQType() {
    if (question.type === "text" || question.type === "number") {
      return (
        <>
          <M_Type question={question}></M_Type>
        </>
      );
    } else if (question.type === "true/false" || question.type === "single") {
      return (
        <>
          <M_MultipleChoice questions={question}></M_MultipleChoice>
        </>
      );
    } else if (question.type === "multiple") {
      return (
        <>
          <M_SelectTrue question={question}></M_SelectTrue>
        </>
      );
    } else if (question.type === "order") {
      return (
        <>
          <M_Order question={question}></M_Order>
        </>
      );
    } else if (question.type === "match") {
      return (
        <>
          <M_ColumnMatch question={question}></M_ColumnMatch>
        </>
      );
    }
  }

  function getButton() {
    if (question.solution.length > 0) {
      return (
        <Button
          borderRadius={"5px"}
          width={"200px"}
          marginTop={"10px"}
          style={{
            width: "200px",
            backgroundColor: "rgba(241, 69, 69, 0.5)",
            padding: "10px",
            borderRadius: "5px",
            fontSize: "0.9rem",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
          onClick={toSolution}
          marginRight={"5em"}
        >
          <Lightbulb></Lightbulb>
        </Button>
      );
    } else return <></>;
  }

  function toSolution() {
    history.push("/solution", { solution: question.solution, questionNumber: questionNumber });
  }
  return (
    <div>
      <Div
        backgroundColor={"#FFFFFF"}
        height={"100%"}
        borderRadius={"5px"}
        padding={"10px"}
      >
        <Typography
          fontWeight={"bold"}
          color={"#00112e"}
          textAlign={"left"}
          padding={"10px"}
          style={{ fontSize: "1rem" }}
        >
          Question {questionNumber + 1}
        </Typography>
        <hr
          style={{
            borderColor: "rgb(0, 17, 46)",
            borderWidth: "1px",
            borderStyle: "solid",
            width: "95%",
          }}
        />
        <QuestionText question={question} />
        <Image src={question.url} width="250px" />
        {getCorrectQType()}
        {getButton()}
      </Div>
    </div>
  );
}
